// extracted by mini-css-extract-plugin
module.exports = {"list":"detail-module--list--2OiQu"};